import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import PropTypes from 'prop-types';
import Stomp from 'webstomp-client';
import DialogComponent from '../Dialog/DialogComponent';

const ProgressDialog = ({ show = false, destroy = false, destination = '' }) => {
  ProgressDialog.prototype = {
    show: PropTypes.bool,
    destroy: PropTypes.bool,
    destination: PropTypes.string,
  };

  const [messageClient, setMessageClient] = useState({});
  const [notificationMessage, setNotificationMessage] = useState({});
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    connectFn();
  }, []);

  useEffect(() => {
    if (connected) {
      disconnectFn();
    }
  }, [destroy]);

  const connectFn = () => {
    const socketPrefix = process.env.NODE_ENV == 'production' ? 'wss' : 'ws';
    const socket = new WebSocket(`${socketPrefix}://${window.location.host}/notify`);
    let stompClient = Stomp.over(socket);
    let token = document.cookie
      .split('; ')
      .find(row => row.startsWith('XSRF-TOKEN'))
      .split('=')[1];
    let headers = {
      'X-XSRF-TOKEN': token,
    };
    stompClient.connect(
      headers,
      frame => {
        setMessageClient({ client: stompClient });
        setConnected(true);
        stompClient.subscribe(destination, data => {
          let notification = JSON.parse(data.body);
          setNotificationMessage(notification);
        });
      },
      error => {
        console.log('error occured', error);
      }
    );
  };

  const disconnectFn = () => {
    if (messageClient.client && messageClient.client !== null) {
      messageClient.client.disconnect();
    }

    setConnected(false);
  };

  return (
    <DialogComponent open={show && Boolean(notificationMessage.message)} hideCloseIcon={true} className="progress-dialog">
      <div className="progress-bar-content">
        <div className="progress-title">
          <div className="progress-title-text">{notificationMessage.title}</div>
          <div className="dot-pulse"></div>
        </div>
        <div className="progress-message">{notificationMessage.message}</div>
        <ProgressBar value={notificationMessage.progress}></ProgressBar>
      </div>
    </DialogComponent>
  );
};

export default ProgressDialog;